var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99544 14.0813C8.31565 14.4049 8.31676 14.9306 7.99793 15.2555C7.70809 15.551 7.2536 15.5787 6.93279 15.3383L6.84085 15.2581L0.240851 8.58894C-0.051116 8.29392 -0.0776758 7.83103 0.161183 7.50546L0.240803 7.41221L6.8408 0.741981C7.16098 0.418393 7.67903 0.419481 7.99788 0.744412C8.28776 1.0398 8.31322 1.50114 8.0749 1.8257L7.99549 1.91866L1.978 8.00089L7.99544 14.0813Z",
    fill: "#FF1C26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackLeft);
export default __webpack_public_path__ + "static/media/back-left.2421bea7737ccac3834272d09f967f74.svg";
export { ForwardRef as ReactComponent };